var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function wordBox(x, y, text, fontSize) {
    var w = text.length * fontSize * 0.58;
    var h = fontSize * 1.15;
    return { x: x, y: y, w: w, h: h };
}
function overlaps(a, b, pad) {
    if (pad === void 0) { pad = 3; }
    return a.x < b.x + b.w + pad && a.x + a.w + pad > b.x && a.y < b.y + b.h + pad && a.y + a.h + pad > b.y;
}
/** Spiral word placement with simple collision avoidance (largest words first). */
export function layoutWordCloud(words, width, height) {
    var e_1, _a;
    var maxVal = Math.max.apply(Math, __spreadArray(__spreadArray([], __read(words.map(function (w) { return w.value; })), false), [1], false));
    var cx = width / 2;
    var cy = height / 2;
    var sorted = __spreadArray([], __read(words), false).sort(function (a, b) { return b.value - a.value; });
    var placed = [];
    var boxes = [];
    try {
        for (var sorted_1 = __values(sorted), sorted_1_1 = sorted_1.next(); !sorted_1_1.done; sorted_1_1 = sorted_1.next()) {
            var w = sorted_1_1.value;
            var fontSize = 12 + (w.value / maxVal) * 26;
            var estW = w.text.length * fontSize * 0.58;
            var angle = 0;
            var radius = 0;
            var found = false;
            var _loop_1 = function (t) {
                var x = cx + radius * Math.cos(angle) - estW / 2;
                var y = cy + radius * Math.sin(angle) - fontSize / 2;
                var box = wordBox(x, y, w.text, fontSize);
                var inBounds = box.x >= 4 &&
                    box.y >= 4 &&
                    box.x + box.w <= width - 4 &&
                    box.y + box.h <= height - 4;
                var clear = inBounds && !boxes.some(function (b) { return overlaps(box, b); });
                if (clear) {
                    placed.push({ text: w.text, x: x, y: y, fontSize: fontSize, value: w.value });
                    boxes.push(box);
                    found = true;
                    return "break";
                }
                angle += 0.42;
                radius += 0.55;
            };
            for (var t = 0; t < 720; t++) {
                var state_1 = _loop_1(t);
                if (state_1 === "break")
                    break;
            }
            if (!found) {
                var x = cx - estW / 2 + (placed.length % 3) * 12;
                var y = cy - fontSize / 2 + (placed.length % 5) * 8;
                placed.push({ text: w.text, x: x, y: y, fontSize: fontSize, value: w.value });
                boxes.push(wordBox(x, y, w.text, fontSize));
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (sorted_1_1 && !sorted_1_1.done && (_a = sorted_1.return)) _a.call(sorted_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return placed;
}
